import React from 'react';

const photo = `${process.env.PUBLIC_URL}/photos/director.jpg`;

const Director = () => {
    return (
        <section id="director" className="section">
            <div className="container">
                <div className="section-head reveal">
                    <h2 className="section-title">Руководитель <span className="accent">организации</span></h2>
                </div>

                <div className="card-glass director-card reveal">
                    <div className="row g-4 g-lg-5 align-items-center">
                        <div className="col-lg-5">
                            <div className="director-photo">
                                <img src={photo} alt="Якименко Вероника Владимировна — директор организации"/>
                            </div>
                        </div>
                        <div className="col-lg-7">
                            <h3 className="person-name">Якименко Вероника Владимировна</h3>
                            <p className="person-role">Директор · вдохновитель и руководитель проектов</p>
                            <p className="person-text">
                                С момента создания организации остаётся бессменным вдохновителем и руководителем
                                всех проектов и волонтёров. За годы работы организации мы работали с несколькими
                                поколениями подростков, формируя их активную жизненную и лидерскую позицию. Многие
                                из них после общения с нами избрали своей профессией педагогическую деятельность,
                                что несомненно радует.
                            </p>
                            <p className="person-text">
                                Своей целью вижу не только поддержание семьи и детства, создание интеграционных
                                площадок для приобретения опыта взаимодействия представителей разных социальных
                                групп и слоёв, но и вовлечение подрастающего поколения россиян в активную
                                социально-ориентированную деятельность.
                            </p>
                        </div>
                    </div>
                </div>
            </div>
        </section>
    );
};

export default Director;
